
import React from "react";
import Vivid from "./pages/vivid";

export default function App() {
  return (
    <Vivid />
  )
}